import React from 'react';
import {connect} from 'react-redux'
import {storeFromArea} from "./../utils";
import AbstractReactComponent from './../AbstractReactComponent';

class ListComponent extends AbstractReactComponent {

    static defaultProps = {
        renderContainer: (child) => <div>{child}</div>
    };

    static PropTypes = {
        area: React.PropTypes.string.isRequired,
        renderItem: React.PropTypes.func.isRequired,
        renderContainer: React.PropTypes.func
    };

    render() {
        const {store, renderItem, renderContainer} = this.props;

        return renderContainer(store.rows.map(renderItem));
    }
}

export default connect((state, props) => ({store: storeFromArea(state, props.area)}))(ListComponent)
